import { render } from "./HomePageLatestProducts.vue?vue&type=template&id=2da85868&scoped=true"
import script from "./HomePageLatestProducts.vue?vue&type=script&lang=js"
export * from "./HomePageLatestProducts.vue?vue&type=script&lang=js"

import "./HomePageLatestProducts.vue?vue&type=style&index=0&id=2da85868&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da85868"]])

export default __exports__